import { createGlobalStyle } from "styled-components";
import { get_color } from "./mixins";

export default createGlobalStyle`
  html[lang="zh-HK"],
  html[lang="zh-CN"]{
    *{
      font-family: "Microsoft JhengHei","微軟正黑體","PingFang HK","Noto Sans CJK TC","Arial","Helvetica Neue","Noto Sans","Helvetica","sans-serif",-apple-system,system-ui!important;
    }
  }
  body {
    padding: 0;
    margin: 0;
    color: ${get_color("grey01")};
  }
`;
